/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-18 11:29:54
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare\'i aç",
    name2: "Rezervasyon yaptırmak",
    name3: "Carlcare ile istediğiniz an siparişinizi kontrol edebilirsiniz.",
    name4: "",
    name5: "Sağda kaydır",
    name6: "Doğrulama tamamlandı",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "Cihaz modelini seçin",
    name2: "Arıza Açıklaması:",
    name3: "Servis mağazasını seçmek için dokunun",
    name4: "Servis Mağazası:",
    name5: "Rezervasyon Saati:",
    name6: "Lütfen cihazınızın sorununu detaylı olarak açıklayın!",
    name7: "Varış saatini seçmek için dokunun",
    name8: "Lütfen size ulaşabileceğimiz doğru iletişim detaylarınızı girin",
    name9: "Mevcut rezervasyon saati aşağıdaki gibidir",
    name10: "Lütfen telefon numaranızı girin",
    name11: "Fiyat",
    name12: "Kişisel bilgi:",
    name13: "Lütfen adınızı girin",
    name14: "Gönder",
    name15: "İptal et",
    name16: "TAMAM",
  },
  shops: {
    name1: "Seçtiğiniz markaya göre, aşağıdaki mağazalar size hizmet verebilir!",
    name2: "Çok yakında daha fazla perakende mağazasıyla hizmetinizdeyiz! Bizi izlemeye devam edin!",
  },
  price: {
    name1: "Marka",
    name2: "Model",
    name3: "ÖĞE",
    name4: "Fiyat",
    name5: "Yardımcı Anımsatıcı:",
    name6: "Bu fiyatlar sadece bilgilendirme amaçlı olup, gerçek fiyat cihazınızın durumuna göre değişiklik gösterir.",
    name7: "Herhangi bir özel simge yoksa, fiyat birimi yerel para birimidir.",
    name8: "Üzgünüz! Geçerli bölgede kullanılabilir fiyat bilgisi yok.",
    name11:"İşçilik Maliyeti",
    name12:"Toplam Fiyat",
    name13: "5. İşçilik maliyeti \"/\" ise işçilik maliyetinin mağazayla görüşülmesi isteniyor.",
    item_main_board: "Ana Kart",
    item_screen_frame: "Ekran (Çerçeve)",
    item_screen_screen_frame: "İkinci Ekran (Çerçeve)",
    item_touch_screen: "Dokunmatik Ekran",
    item_camera: "Kamera",
    item_fixed_focus_camera: "Sabit Odaklı Kamera",
    item_auto_focus_camera: "Otomatik Odaklı Kamera",
    item_screen: "Ekran",
    item_secondary_screen: "İkinci Ekran",
    item_fingerprint_module: "Parmak İzi Modülü",
    item_speaker: "Hoparlör",
    item_receiver: "Alıcı",
    item_small_board: "Küçük Pano",
    item_battery_cover: "Batarya Kapağı",
    item_battery: "Batarya",
    item_charger: "Şarj Cihazı",
    item_usb_cable: "USB Kablosu",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Veri yok",
    name2: "Servis Sağlayıcısı:",
    name3: "Hizmet Markası:",
    name4: "Telefon:",
    name5: "Siparişin Miktarı:",
    name6: "Servis Derecesi",
    name7: "Servis Ortamı:",
    name8: "Servis Yaklaşımı:",
    name9: "Servis Verimliliği:",
    name10: "Servis Kalitesi:",
    name11: "Müşteri Değerlendirmesi",
    name12:"kime",
    name13:"Kapalı",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare\'i aç",
    name1: "Öncelikli hizmete erişmek için lütfen rezervasyon bilgisinin ekran görüntüsünü alın ve fiş olarak kaydedin.",
    name2: "Başarıyla gönderildi",
    name3: "1. Verileri temizleyin",
    name4: "Telefonunuzdaki önemli özel verileri lütfen önceden yedekleyin",
    name5: "2. Güç açma parolasını devre dışı bırak",
    name6: "Servis mağazasına gitmeden önce lütfen şunları yapın:",
    name7: "Servis Mağazası:",
    name8: "Rezervasyon Saati:",
    name9: "Arıza Açıklaması:",
    name10: "Cihaz Modeli:",
    name11: "Sipariş Numarası:",
    name12: "Sipariş Bilgisi",
  },
  title: {
    
    name1: "Aşağıdaki ülkeleri destekler:",
    name2: "Model Seçin",
    name3: "Rezervasyon",
    name4: "Servis Mağazası Detayları",
    name5: "Servis Mağazasını Seçin",
  },
  error: {
    
    name1: "Veri yok. Lütfen onarım bilginizi kontrol edin",
    name2: "Daha fazla yardıma mı ihtiyacınız var? Lütfen bizimle iletişime geçin.",
    name3: "Üzgünüz, mevcut bölgede Carlcare merkezi yok.",
    name4: "Lütfen önce bir servis merkezi seçin",
    name5: "Başarısız oldu",
    name6: "Lütfen önce cihaz modelini seçin",
    name7: "Detaylar",
    name8: "Lütfen ihtiyaçlarınızı ayrıntılı olarak açıklayın",
    name9: "",
  },
  add1:{
    "name0": "tr",
    "name1": "Siparişiniz onaylandı. Varışınızı sabırsızlıkla bekliyoruz.",
    "name2": "Şehri seçin",
    "name3": "Lütfen %1$s haneli bir telefon numarası girin.",
    "name4": "Hafta İçi Saatler",
    "name5": "Pazartesi",
    "name6": "Salı",
    "name7": "Çarşamba",
    "name8": "Perşembe",
    "name9": "Cuma",
    "name10": "Cumartesi",
    "name11": "Pazar",
    "name12": "Ülke gir ve ara"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Diğerleri",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Yönlendirme için Dokunun",
    name3:"Siparişinizi değerlendirmek için Carlcare uygulamasını açın",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Servis Seçin",
    name7:"Ücretsiz Temizlik",
    name8:"Yazılım Yükseltme",
  },
  cancelorder:{
    "cancelReason0": "Hatalı bilgi",
    "cancelReason1": "Zamanında ulaşamaz",
    "cancelReason2": "Mükerrer sipariş/benim siparişim değil",
    "cancelReason3": "Arıza tekrarlamıyor",
    "cancelReason4": "Sadece test/sorgu/etkinlik/… için",
    "cancelReason5": "Yüksek fiyat",
    "cancelReason6": "Malzeme sıkıntısı",
    "cancelReason7": "Ayrıştırılmış hizmet yok",
    "cancelReason8": "Mağaza çok uzak",
    "cancelReason9": "Mağaza kapalı",
    "cancelReason10": "Kötü hizmet tavrı",
    "cancelReason11": "Diğer markalar için değiştirme/onarım",
    "cancelReason12": "Mağazayı bulunamıyor",
    "cancelReason13": "Diğer",
    "cancelOrder": "Siparişi İptal Et",
    "reason_dialog_title": "Lütfen iptal etme nedeninizi söyleyin",
    "Cancel": "İptal et",
    "OK": "TAMAM",
    "name1": "Doğrulama kodunu girin",
    "name2": "Geçersiz doğrulama kodu",
    "repair_reservation_detail_canceled": "Bu sipariş İptal Edildi!",
    "purchase_cancel_dialog_content": "Siparişinizi iptal etmeyi onaylıyor musunuz?",
    "yes": "Evet",
    "no": "Hayır"
}
};
